/**
 *
 * 方案汇报 - 透明度配置 1.0
 *
 * 功能点:修改瓦片透明度、亮度,倾斜摄影透明度.
 * 场景:方案汇报
 *
 */
import Vue from "@/main";

/**
 * 调整瓦片透明度
 */
export function adjustTileOpacity(value) {
  console.log("adjustTileOpacity", Vue.$GLOBAL.tileLayerIds, value);
  Vue.$GLOBAL.tileLayerIds.forEach((item) => {
    let tileLayer = Vue.$GLOBAL.map.getLayerById(item);
    if (tileLayer != null && tileLayer.opacity != null)
      tileLayer.opacity = value; //透明度 0.0-1.0
    if (Vue.$GLOBAL.mapClone === null || Vue.$GLOBAL.mapClone === undefined)
      return;
    let tileLayer2 = Vue.$GLOBAL.mapClone.getLayerById(item);
    if (tileLayer2 != null && tileLayer2.brightness != null)
      tileLayer2.opacity = value;
  });
}

/**
 * 调整瓦片亮度
 */
export function adjustTileBrightness(value) {
  console.log("adjustTileOpacity", Vue.$GLOBAL.tileLayerIds, value);
  Vue.$GLOBAL.tileLayerIds.forEach((item) => {
    let tileLayer = Vue.$GLOBAL.map.getLayerById(item);
    if (tileLayer != null && tileLayer.brightness != null)
      tileLayer.brightness = value; //亮度 0.0-3.0
    if (Vue.$GLOBAL.mapClone === null || Vue.$GLOBAL.mapClone === undefined)
      return;
    let tileLayer2 = Vue.$GLOBAL.mapClone.getLayerById(item);
    if (tileLayer2 != null && tileLayer2.brightness != null)
      tileLayer2.brightness = value;
  });
}

/**
 * 调整瓦片对比度
 */
export function adjustTileContrast(value) {
  Vue.$GLOBAL.tileLayerIds.forEach((item) => {
    let tileLayer = Vue.$GLOBAL.map.getLayerById(item);
    if (tileLayer != null && tileLayer.contrast != null)
      tileLayer.contrast = value; //对比度 0.0-3.0
    if (Vue.$GLOBAL.mapClone === null || Vue.$GLOBAL.mapClone === undefined)
      return;
    let tileLayer2 = Vue.$GLOBAL.mapClone.getLayerById(item);
    if (tileLayer2 != null && tileLayer2.brightness != null)
      tileLayer2.contrast = value;
  });
}

/**
 * 调整瓦片色彩
 */
export function adjustTileHue(value) {
  Vue.$GLOBAL.tileLayerIds.forEach((item) => {
    let tileLayer = Vue.$GLOBAL.map.getLayerById(item);
    if (tileLayer != null && tileLayer.hue != null) tileLayer.hue = value; //色彩 0.0-1.0
    if (Vue.$GLOBAL.mapClone === null || Vue.$GLOBAL.mapClone === undefined)
      return;
    let tileLayer2 = Vue.$GLOBAL.mapClone.getLayerById(item);
    if (tileLayer2 != null && tileLayer2.brightness != null)
      tileLayer2.hue = value;
  });
}

/**
 * 调整瓦片饱和度
 */
export function adjustTileSaturation(value) {
  Vue.$GLOBAL.tileLayerIds.forEach((item) => {
    let tileLayer = Vue.$GLOBAL.map.getLayerById(item);
    if (tileLayer != null && tileLayer.saturation != null)
      tileLayer.saturation = value; //饱和度 0.0-3.0
    if (Vue.$GLOBAL.mapClone === null || Vue.$GLOBAL.mapClone === undefined)
      return;
    let tileLayer2 = Vue.$GLOBAL.mapClone.getLayerById(item);
    if (tileLayer2 != null && tileLayer2.brightness != null)
      tileLayer2.saturation = value;
  });
}

/**
 * 调整瓦片伽马值
 */
export function adjustTileGamma(value) {
  Vue.$GLOBAL.tileLayerIds.forEach((item) => {
    let tileLayer = Vue.$GLOBAL.map.getLayerById(item);
    if (tileLayer != null && tileLayer.gamma != null) tileLayer.gamma = value; //伽马值 0.0-3.0
    if (Vue.$GLOBAL.mapClone === null || Vue.$GLOBAL.mapClone === undefined)
      return;
    let tileLayer2 = Vue.$GLOBAL.mapClone.getLayerById(item);
    if (tileLayer2 != null && tileLayer2.brightness != null)
      tileLayer2.gamma = value;
  });
}

/**
 * 调整地下模式透明度
 */
export function adjustUndergroundAlpha(value) {
  let bimAlpha = Vue.$GLOBAL.map.getThing("bimAlpha");
  if (bimAlpha && bimAlpha.state == "added") {
    bimAlpha.alpha = value;
  } else {
    let underground = new mars3d.thing.Underground({
      alpha: value,
      id: "bimAlpha",
    });
    Vue.$GLOBAL.map?.addThing(underground);
  }

  // let underground = new mars3d.thing.Underground({
  //   alpha: value, //透明度 0.0-1.0
  //   id: "bimAlpha",
  // });
  // Vue.$GLOBAL.map.addThing(underground);
}

/**
 * 调整模倾斜模型明度
 */
export function adjustOsgbOpacity(value, id, fn, ...list) {
  let map = Vue.$GLOBAL.map;
  if (list.length > 0) {
    let { mapType } = list[0];
    if (mapType == "clone") {
      map = Vue.$GLOBAL.mapClone;
    }
  }
  Vue.$GLOBAL.osgbTilesetLayerIds.forEach((item) => {
    // let tilesetLayer = Vue.$GLOBAL.map.getLayerById(item);
    let tilesetLayer = map.getLayer(item, "modelId");
    if (tilesetLayer != null && tilesetLayer.opacity != null)
      tilesetLayer.opacity = value; //透明度 0.0-1.0
  });
}
